import { PaymentMethod } from '@/app/shared/enums';
import { Model } from '@/app/shared/models/model';
export class StatementModel extends Model {
  public InstallmentId!: string;
  public InstallmentNumber!: number;
  public InstallmentOurCode?: string;
  public InstallmentYearReference!: number;
  public InstallmentMonthReference!: number;
  public TransactionDate!: Date;
  public PaymentInfoPaymentMethod!: PaymentMethod;
  public ContractId?: string;
  public CovenantId!: string;
}
